// src/pages/ThankYou.jsx
import { Link } from "react-router-dom";
import "../App.css";

export default function ThankYou() {
  const secretId = localStorage.getItem("secretId") || "";

  return (
    <div className="ty-page" style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#f8fafc" }}>
      <div
        className="ty-card"
        style={{
          width: "min(720px, 92vw)",
          background: "#fff",
          borderRadius: 16,
          boxShadow: "0 20px 40px rgba(0,0,0,.12)",
          padding: 24,
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: 72,
            height: 72,
            margin: "0 auto 12px",
            borderRadius: "50%",
            background: "#10b981",
            color: "#fff",
            display: "grid",
            placeItems: "center",
            fontSize: 36,
            fontWeight: 800,
          }}
          aria-hidden
        >
          ✓
        </div>

        <h1 style={{ margin: "6px 0 6px", fontSize: 28, fontWeight: 800, color: "#111827" }}>
          Rejestracja zakończony!
        </h1>
        <p style={{ margin: 0, color: "#4b5563" }}>
          Twoje dane wydarzenia zostały zarejestrowane. Możesz wrócić do edycji albo przejść do logowania.
        </p>

        <div style={{ display: "flex", gap: 12, justifyContent: "center", marginTop: 18, flexWrap: "wrap" }}>
          <Link to="/" className="ty-btn ty-btn--primary">
            Wróć do edycji
          </Link>
          {secretId ? (
            <a
              href={`/?secretId=${encodeURIComponent(secretId)}`}
              className="ty-btn"
              title="Otwórz stronę z tym samym identyfikatorem w URL (opcjonalnie)"
            >
             przejdź do logowania
            </a>
          ) : null}
        </div>
      </div>

      <style>{`
        .ty-btn {
          padding: 10px 14px;
          border-radius: 10px;
          border: 1px solid #d1d5db;
          background: #fff;
          color: #111827;
          text-decoration: none;
          cursor: pointer;
        }
        .ty-btn--primary {
          background: #6366f1;
          border-color: #6366f1;
          color: #fff;
        }
        .ty-btn:hover { filter: brightness(.97); }
      `}</style>
    </div>
  );
}
